<div class="flex topbar-height px-4 border-b border-neutral-200">
  <div class="flex gap-3 items-center min-w-0">
    @if (layoutService.mobileNavOpen()) {
      <!-- Fixed so it escapes the main-column stacking context and sits above the drawer -->
      <button
        type="button"
        class="fixed top-3.5 left-4 z-[70] inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-900 shadow-md lg:hidden"
        aria-label="Close menu"
        [attr.aria-expanded]="true"
        (click)="toggleMobileNav()">
        <app-svg-icon
          class="text-slate-900"
          src="assets/icons/close.svg"
          [size]="22" />
      </button>
    } @else {
      <button
        type="button"
        class="inline-flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent text-slate-700 transition hover:bg-slate-100 lg:hidden"
        aria-label="Open menu"
        [attr.aria-expanded]="false"
        (click)="toggleMobileNav()">
        <app-svg-icon
          class="text-slate-700"
          src="assets/icons/menu.svg"
          [size]="22" />
      </button>
      <app-breadcrumb></app-breadcrumb>
    }
  </div>

  <div class="ml-auto flex items-center">
    <app-account-menu-button />
  </div>
</div>
